import { GET_RECAPTCHA } from '../../actions/recaptcha/recaptcha';

const getInitialState = {
  error: null,
  loaded: false,
  loading: false,
  data: [],
};

/**
 * recaptcha reducer.
 * @function recaptcha
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
export const recaptchaReducer = (state = getInitialState, action = {}) => {
  switch (action.type) {
    case `${GET_RECAPTCHA}_PENDING`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
        data: [],
      };
    case `${GET_RECAPTCHA}_FAIL`:
      return {
        ...state,
        error: action.error,
        loaded: false,
        loading: false,
        data: [],
      };
    case `${GET_RECAPTCHA}_SUCCESS`:
      return {
        ...state,
        error: null,
        loaded: true,
        loading: false,
        data: action.result,
      };
    default:
      return state;
  }
};
